module.exports = new __parcel__URL__("../images/PCS.02479d1b.png").toString();